import AddAdminsScreen from "../modules/users/AddAdminScreen"

export default function AddAdmin() {
  return (
    <>
      <AddAdminsScreen />
    </>
  )
}
